import React, { useState, useEffect } from 'react';
import {
	SdfFocusPane,
	SdfTabGroup,
	SdfTab,
} from '@synerg/react-components';
import PartnerDetailsAndAssignContact from './PartnerDetailsAndAssignContact';
import { withPermissionsAndRoles } from '../session';
import MembersTab  from './adminMembers/members';
import CertificateDetails from './certificateDetails';
import { AssignedApps } from './assignedApps/assignedApps';
import AcceleratedPartner from './acceleratedPartner';

function PartnerOrgDetails({ partner, setShowView, roles, getPartners, setDeletedPartner, preSelectedTab = "Members" }) {
	const [selectedTab, setSelectedTab] = useState(preSelectedTab);
	const [hasUpdatedContacts, setHasUpdatedContacts] = useState(false);
	const [partnerDetails, setPartnerDetails] = useState(partner);

	useEffect(() => {
		if (hasUpdatedContacts) {
			getPartners();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasUpdatedContacts]);

	return (
		<SdfFocusPane visible={true}
			paneType="anchored"
			size="lg"
			hideAcceptButton={true}
			hideDismissButton={true}
			onSdfDismiss={() => { setShowView(false); }}
			closeable={true}
			dismissOnClickOutside={true}
		>
			<PartnerDetailsAndAssignContact
				setHasUpdatedContacts={setHasUpdatedContacts}
				hasUpdatedContacts={hasUpdatedContacts}
				setDeletedPartner={setDeletedPartner}
				partner={partnerDetails}
				roles={roles}
				onClose={() => { }}
				partnerType={partner.partnerType}
				clientId={partner.clientId}
				setPartner={setPartnerDetails}
			/>
			<div className={"mx-4 mt-2"}>
				<SdfTabGroup onSdfChange={({ detail }) => { setSelectedTab(detail.value) }}>
					<SdfTab value="Members" active={selectedTab === "Members"}>Members</SdfTab>
					<SdfTab value="Certificates" active={selectedTab === "Certificates"}>Certificates</SdfTab>
					<SdfTab value="AssignedApps" active={selectedTab === "AssignedApps"}>Assigned apps</SdfTab>
					<SdfTab value="AcceleratedPartner" active={selectedTab === "AcceleratedPartner"}>Accelerated Integrator</SdfTab>
				</SdfTabGroup>
				{selectedTab === "Members" && <MembersTab partner={partner}/>}
				{selectedTab === "Certificates" && <CertificateDetails partner={partnerDetails} />}
				{selectedTab === "AssignedApps" && <AssignedApps partnerDetails={partner} />}
				{selectedTab === "AcceleratedPartner" && <AcceleratedPartner partner={partnerDetails} />}
			</div>
		</SdfFocusPane>
	)
}

export default withPermissionsAndRoles(PartnerOrgDetails);
